import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "font-medium" }
const _hoisted_2 = { class: "text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.redirectToWiki && _ctx.redirectToWiki(...args))),
    class: "rounded-lg bg-greyLight flex space-x-3 items-center py-2 px-3 mt-6"
  }, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-3xl text-blue" }, [
      _createElementVNode("i", { class: "fas fa-question-circle" })
    ], -1)),
    _createElementVNode("div", null, [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.title), 1),
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.subtitle), 1)
    ])
  ]))
}